import React from "react";
import { useLanguage } from "@/lib/i18n";
import LegalLayout from "@/components/legal/LegalLayout";

export default function CookiePolicy() {
  const { t } = useLanguage();
  return (
    <LegalLayout titleKey="legal.cookies.title" testid="legal-cookies-page">
      <Section title={t("legal.cookies.s1.title")}>
        <p>{t("legal.cookies.s1.body")}</p>
      </Section>

      <Section title={t("legal.cookies.s2.title")}>
        <p>{t("legal.cookies.s2.body")}</p>
        <p className="mt-2 text-sm text-[#475569]">
          {t("legal.cookies.s2.note")}
        </p>
      </Section>

      <Section title={t("legal.cookies.s3.title")}>
        <div className="overflow-x-auto">
          <table className="w-full text-sm border-collapse">
            <thead>
              <tr className="border-b border-slate-200">
                <th className="text-left py-2 pr-3 font-sans-display text-[#0B2545]">
                  {t("legal.cookies.s3.col1")}
                </th>
                <th className="text-left py-2 pr-3 font-sans-display text-[#0B2545]">
                  {t("legal.cookies.s3.col2")}
                </th>
                <th className="text-left py-2 font-sans-display text-[#0B2545]">
                  {t("legal.cookies.s3.col3")}
                </th>
              </tr>
            </thead>
            <tbody>
              <tr className="border-b border-slate-100">
                <td className="py-2 pr-3 font-mono text-xs">aim_lang</td>
                <td className="py-2 pr-3">{t("legal.cookies.s3.row1Desc")}</td>
                <td className="py-2">{t("legal.cookies.s3.persistent")}</td>
              </tr>
              <tr className="border-b border-slate-100">
                <td className="py-2 pr-3 font-mono text-xs">aim_cookie_consent</td>
                <td className="py-2 pr-3">{t("legal.cookies.s3.row2Desc")}</td>
                <td className="py-2">{t("legal.cookies.s3.persistent")}</td>
              </tr>
            </tbody>
          </table>
        </div>
        <p className="mt-3 text-sm text-[#475569]">
          {t("legal.cookies.s3.note")}
        </p>
      </Section>

      <Section title={t("legal.cookies.s4.title")}>
        <p>{t("legal.cookies.s4.body")}</p>
      </Section>

      <Section title={t("legal.cookies.s5.title")}>
        <p>{t("legal.cookies.s5.body")}</p>
      </Section>
    </LegalLayout>
  );
}

function Section({ title, children }) {
  return (
    <section>
      <h2 className="font-sans-display text-lg text-[#0B2545] tracking-tight mt-8 mb-3">
        {title}
      </h2>
      {children}
    </section>
  );
}
